// @ts-nocheck
import React, { useContext, useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { Filter } from './Filter';
import SiteContext from '../Context/SiteContext';


export const DailyTransaction = ({ transactions, deleteTransaction }) => {

    const stateContext = useContext(SiteContext);
    const customSort = (a, b) => {
        const arrayA = a.date.split("/");
        const arrayB = b.date.split("/");

        if (arrayA[2] > arrayB[2]) {
            return 1;
        }
        else if (arrayA[2] === arrayB[2]) {
            if (arrayA[1] > arrayB[1]) {
                return 1;
            }
            else if (arrayA[1] < arrayB[1]) {
                return -1;
            }
            else if (arrayA[1] === arrayB[1]) {
                if (arrayA[0] > arrayB[0]) {
                    return 1;
                }
                else if (arrayA[0] < arrayB[0]) {
                    return -1;
                }
            }
        }
        else if (arrayA[2] < arrayB[2]) {
            return -1;
        }

        // Sorting by Alpabetical Order when dates are same
        if (arrayA[0] === arrayB[0] && arrayA[1] === arrayB[1] && arrayA[2] === arrayB[2]) {
            if (a.name > b.name) {
                return 1;
            }
            else if (a.name < b.name) {
                return -1;
            }
        }
        return 0;
    }

    const [toggle, setToggle] = useState(false);

    const [amountFilter, setAmountFilter] = useState(false);
    const [amountFilterLowToHigh, setAmountFilterLowToHigh] = useState(false);
    const [total, setTotal] = useState(0);
    const [searchValue, setSearchValue] = useState("");
    const [searchTotal, setSearchTotal] = useState(0);
    const [searchNoTransactions, setSearchNoTransactions] = useState(0);
    const [searchTotalPercentage, setSearchTotalPercentage] = useState(0);

    var sortedTransactions = transactions.sort(customSort);
    const [searchedTransactions, setSearchedTransactions] = useState();
    // const sortedTransactions = transactions.sort((a, b) => { return (a.date) - (b.date) })

    if (amountFilter) {
        sortedTransactions = transactions.sort((a, b) => { return (b.amount) - (a.amount) })
    }

    if (amountFilterLowToHigh) {
        sortedTransactions = transactions.sort((a, b) => { return (a.amount) - (b.amount) })
    }

    useEffect(() => {
        calculateTotal();
    }, [sortedTransactions])

    function calculateTotal() {
        var sum = 0;
        sortedTransactions.map((transaction) => {
            sum += Number(transaction.amount);
        })

        setTotal(sum);
    }

    function handleKeyUp() {
        console.log(searchedTransactions)
        var tsearchedTransactions = sortedTransactions.filter((transaction) => {
            return transaction.name.toString().toLowerCase().indexOf(searchValue.toString().toLowerCase()) !== -1;
        })
        var sum = 0;
        var noOfTransaction = 0;

        tsearchedTransactions.map((transaction) => {
            sum += Number(transaction.amount);
            noOfTransaction++;
        })

        // Percentage of Total in Search
        var searchPercent = ((Number(sum) / Number(total)) * 100).toFixed(2);

        setSearchTotalPercentage(searchPercent);
        setSearchNoTransactions(noOfTransaction);
        setSearchTotal(sum);
        setSearchedTransactions(tsearchedTransactions);
    }

    if (stateContext.toggleSearch) {
        return (
            <div className="dailyTransaction">


                {stateContext.toggleSearch && <div className='search'><input type='text' value={searchValue} placeholder='Search Transactions...' onKeyUp={handleKeyUp} onChange={(e) => setSearchValue(e.target.value)}></input>
                    <span onClick={stateContext.handleSearchClose}>X</span>
                </div>
                }
                <div className="row head">
                    <div className="srno">Sr No</div>
                    <div className="date">Date</div>
                    <div className="name">Name</div>
                    <div className="amount">Amount</div>
                    {/* <div className="edit">Edit</div> */}
                    <div className="deletehead"></div>
                </div>
                {
                    sortedTransactions.filter((item) => {
                        return searchValue.toLowerCase() === "" ? item : item.name.toLowerCase().includes(searchValue.toLowerCase());
                    }).map((transaction) => (
                        <div className="row">
                            <div className="srno" contentEditable={toggle}>{transaction.srno}</div>
                            <div className="date" contentEditable={toggle}>{transaction.date}</div>
                            <div className="name" contentEditable={toggle}>{transaction.name}</div>
                            <div className="amount" contentEditable={toggle}>&#8377; {transaction.amount}</div>


                            <FontAwesomeIcon icon={faTrash} className='delete' onClick={() => deleteTransaction(transaction.id)} />


                        </div>
                    ))}

                <div className="searchStats">
                    <p>Search Total: <b>&#8377; {searchTotal}</b></p>
                    <p>Percentage Expense: <b>{searchTotalPercentage}%</b></p>
                    <p>No of Transactions: <b>{searchNoTransactions}</b></p>
                </div>

                <div className="total">
                    Total : <b> &#8377;{total}</b>
                </div>

                {/*Toggle Here */}
                {stateContext.toggleFilter && <Filter setAmountFilter={setAmountFilter} amountFilter={amountFilter} setAmountFilterLowToHigh={setAmountFilterLowToHigh} amountFilterLowToHigh={amountFilterLowToHigh} />}
            </div>
        )
    }

    else {
        return (
            <div className="dailyTransaction">


                {stateContext.toggleSearch && <div className='search'><input type='text' placeholder='Search Transactions...' onKeyUp={handleKeyUp} onChange={(e) => setSearchValue(e.target.value)}></input>
                    <span onClick={stateContext.handleSearchClose}>X</span>
                </div>
                }
                <div className="row head">
                    <div className="srno">Sr No</div>
                    <div className="date">Date</div>
                    <div className="name">Name</div>
                    <div className="amount">Amount</div>
                    {/* <div className="edit">Edit</div> */}
                    <div className="deletehead"></div>
                </div>
                {
                    sortedTransactions.map((transaction) => (
                        <div className="row">
                            <div className="srno" contentEditable={toggle}>{transaction.srno}</div>
                            <div className="date" contentEditable={toggle}>{transaction.date}</div>
                            <div className="name" contentEditable={toggle}>{transaction.name}</div>
                            <div className="amount" contentEditable={toggle}>&#8377; {transaction.amount}</div>


                            <FontAwesomeIcon icon={faTrash} className='delete' onClick={() => deleteTransaction(transaction.id)} />


                        </div>
                    ))}

                <div className="total">
                    Total : <b> &#8377;{total}</b>
                </div>

                {/*Toggle Here */}
                {stateContext.toggleFilter && <Filter setAmountFilter={setAmountFilter} amountFilter={amountFilter} setAmountFilterLowToHigh={setAmountFilterLowToHigh} amountFilterLowToHigh={amountFilterLowToHigh} />}
            </div>
        )
    }
}